import api from "@/api/axios";
export default {
  namespaced: true,
  state: {
    delivery_data: null,
  },
  mutations: {
    SET_DELIVERY_LIST(state, payload) {
      state.delivery_data = payload;
    },
  },
  actions: {
    async getDeliveryList({ commit }, payload) {
      try {
        commit("setLoading", true, { root: true });
        await api
          .get("/admin/delivery-settings", {
            params: {
              per_page: payload.per_page ? payload.per_page : 15,
              page: payload.page ? payload.page : 1,
            },
          })
          .then((res) => {
            commit("SET_DELIVERY_LIST", res.data);
            commit("setLoading", false, { root: true });
          });
      } catch (error) {
        commit("setLoading", false, { root: true });
        return error;
      }
    },
  },
};
